import { useCallback } from 'react';

import { useQuizzes } from '~teacher/hook';

import { QuizItemCache } from '../../../../../api/quiz/getQuizzes/normalize/toQuizItemCache';
import { uniqueIdFactory } from '../../../../../api/quiz/getQuizzes/normalize/uniqueIds';

interface UseQuizzesFolderParams {
  folderId: number;
}

export function useQuizzesFolder({ folderId }: UseQuizzesFolderParams) {
  const select = useCallback(
    (quizItemCache: QuizItemCache) => {
      const quizOrFolder =
        quizItemCache.itemById[uniqueIdFactory['folder'].toUniqueId(folderId)];
      if (quizOrFolder?.type === 'folder') {
        return quizOrFolder;
      }
    },
    [folderId]
  );

  return useQuizzes({
    select: select,
  });
}
